import { render, staticRenderFns } from "./Topic.vue?vue&type=template&id=f616ce54&"
import script from "./Topic.vue?vue&type=script&lang=js&"
export * from "./Topic.vue?vue&type=script&lang=js&"
import style0 from "./Topic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports